import { render, staticRenderFns } from "./NuveiUserForm.vue?vue&type=template&id=c62ecfd0&scoped=true&"
import script from "./NuveiUserForm.vue?vue&type=script&lang=js&"
export * from "./NuveiUserForm.vue?vue&type=script&lang=js&"
import style0 from "./NuveiUserForm.vue?vue&type=style&index=0&id=c62ecfd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62ecfd0",
  null
  
)

export default component.exports